
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeaserSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teaser_GlobalSet"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedCasesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relatedNewsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relatedJobsCount"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":106}};
    doc.loc.source = {"body":"fragment TeaserSettings on teaser_GlobalSet {\n  relatedCasesCount\n  relatedNewsCount\n  relatedJobsCount\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
